export default __webpack_public_path__ + "static/media/monkey-5.911986a4.png";